import React from 'react'
import './Whatwedo.css'
import s1 from "../Images/s1.png";
import s2 from "../Images/s2.png";
import s3 from "../Images/s3.png";
import s4 from "../Images/s4.png";
import s5 from "../Images/s5.png";
import s6 from "../Images/s6.png";
function Whatwedo() {
    const data = [
        {
            id: 1,
            image: s1,
            heading: "Research & Discovery",
            para: "Every great product begins with understanding the user. Our team conducts in-depth user research, competitor analysis, and customer journey mapping to uncover pain points, motivations, and expectations. These insights allow us to make data-driven decisions that guide the design process, ensuring that every feature we create solves real-world problems and aligns with your business goals."
        },
        {
            id: 2,
            image: s2,
            heading: "Product Design",
            para: "We transform ideas into functional solutions tailored for web, mobile, and SaaS platforms. Our product design process covers everything from initial concept development and wireframing to high-fidelity prototypes, ensuring usability and flexibility at every stage. The result is a product that not only looks good but also adapts as your business grows."
        },
        {
            id: 3,
            image: s3,
            heading: "Visual Design",
            para: "Visual design is about more than aesthetics - it’s about creating a brand identity that users connect with. We craft visually consistent, engaging interfaces using impactful typography, color schemes, imagery, and layouts. Our goal is to make your digital product stand out while delivering an intuitive and delightful user experience."
        },
        {
            id: 4,
            image: s4,
            heading: "User Interface (UI)",
            para: "A great interface bridges the gap between users and technology. We design clean, interactive, and user-friendly UI components optimized for seamless navigation and accessibility. From buttons and forms to dashboards and workflows, every element is thoughtfully designed to improve usability and encourage engagement."
        },
        {
            id: 5,
            image: s5,
            heading: "Interaction & Motion Design",
            para: "Micro-interactions and motion bring digital products to life. We use subtle animations, transitions, and feedback elements to enhance usability, guide user behavior, and create more intuitive experiences. These small design touches make your product more engaging and memorable without overwhelming the user."
        },
        {
            id: 6,
            image: s6,
            heading: "Delivery & Handoff",
            para: "Our process doesn’t stop at design—we ensure a smooth transition to development. We provide developer-ready assets, detailed design documentation, and ongoing collaboration with your dev team to guarantee flawless implementation. Even after handoff, we remain available for support, iteration, and optimization to keep your product performing at its best."
        },
    ]
    return (
        <div id='whatwedo'>
            <div className="section">
                <div className="container">
                    {/* <h3 className="blueheading">
                        What We Offer
                    </h3> */}
                    <h1 className="heading">
                        BastionEx Delivers the Best UI UX Design Services
                    </h1>
                    <p className="newpara">
                  The best UI UX design services combine creativity, usability, and technology to deliver intuitive, engaging digital experiences. Choose our UI & UX design services to transform your ideas into exceptional products. </p>
                    <div className="servicebox">
                        {data.map((item) => {
                            return (
                                <div className="service-card" key={item.id}>
                                    <div className="cardLeft">
                                        <div>
                                            <h3 className="blueheading">0{item.id}</h3>
                                            <h1 className="heading">{item.heading}</h1>
                                        </div>
                                        <p className="newpara">{item.para}</p>
                                    </div>
                                    <div className="cardRight">

                                        <img src={item.image} alt="" />
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Whatwedo